import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ProductsBasic from '@/components/v2/inquiry/ProductsBasic';
import ProductDelete from '@/plugins/graphql/mutations/v2/inquiry/product-delete.gql';
import UpdateProductStatus from '@/plugins/graphql/mutations/v2/inquiry/update-product-status.gql';
import ProductsBasicQuery from '@/plugins/graphql/queries/v2/inquiry/products-basic.gql';
import { Mutation } from 'vuex-class';
import { successfulUpdate, successfulDestroy } from '@/helpers/mixins/LocalizationHelper';
import { omitBy, isNull } from 'lodash';
/**
 * Inquiry Product Manager
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.0.18}
 */
let ProductsManager = class ProductsManager extends Mixins(FormMixin) {
    constructor() {
        super(...arguments);
        this.keyword = null;
        this.selectedProductUuid = null;
    }
    toggleConfirmation(uuid) {
        this.selectedProductUuid = uuid;
        this.showConfirmationDialog();
    }
    goToProductDetailsPage(uuid) {
        this.$router.push({
            name: 'inquiry-product-details',
            params: {
                uuid,
            },
        });
    }
    goToProductEditPage(uuid) {
        this.$router.push({
            name: 'inquiry-products-edit',
            params: {
                uuid,
            },
        });
    }
    async updateStatus(active, inquiryProductUuid) {
        this.requestOnFlight();
        await this.$apollo
            .mutate({
            mutation: UpdateProductStatus,
            variables: {
                input: {
                    inquiryProductUuid,
                    active: !!active,
                },
            },
        })
            .then(() => {
            const msg = successfulUpdate('Product Publish Status');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async uponConfirm() {
        this.requestOnFlight();
        await this.delete()
            .then(() => {
            const msg = successfulDestroy('Product');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
    async delete() {
        const vm = this;
        if (!this.selectedProductUuid) {
            return;
        }
        await this.$apollo.mutate({
            mutation: ProductDelete,
            variables: {
                input: {
                    productUuid: this.selectedProductUuid,
                },
            },
            update: (cache, { data }) => {
                const { product } = data.inquiryProductDelete;
                const variables = {
                    appUuid: vm.appUuid,
                    limit: vm.limit,
                };
                const queryOptions = {
                    query: ProductsBasicQuery,
                    variables: omitBy(variables, isNull),
                };
                const { fetchInquiryProductsByApp } = cache.readQuery({
                    ...queryOptions,
                });
                const deletedProduct = (dp) => {
                    return dp.node.uuid !== product.uuid;
                };
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchInquiryProductsByApp: {
                            ...fetchInquiryProductsByApp,
                            edges: fetchInquiryProductsByApp.edges.filter(deletedProduct),
                        },
                    },
                });
            },
        });
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], ProductsManager.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ProductsManager.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Prop({ type: String, required: true })
], ProductsManager.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: Number, required: true })
], ProductsManager.prototype, "limit", void 0);
__decorate([
    Prop({ type: String, required: false })
], ProductsManager.prototype, "keyword", void 0);
ProductsManager = __decorate([
    Component({
        components: {
            ConfirmationDialog,
            BaseOverlayLoader,
            ProductsBasic,
        },
    })
], ProductsManager);
export default ProductsManager;
